import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {forkJoin, Observable} from "rxjs";
import {map, shareReplay} from "rxjs/operators";
import {GeneralService} from "../general.service";
import {StorageService} from "../storage.service";

@Injectable({
  providedIn: 'root'
})
export class TagCategoryService extends GeneralService {
  businessType;
  tagData1$;
  tagData2$;
  tagData$;

  constructor(
      public http: HttpClient,
      private storageService: StorageService,
      @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/tag/tagCategory');
    this.businessType = this.storageService.getBusinessTypeItem();

    this.tagData1$ = this.http.post(this.httpBase + '/tag/tagCategory/search', {businessType: -1}).pipe(map(res => res['data']));
    this.tagData2$ = this.http.post(this.httpBase + '/tag/tagCategory/search', {businessType: this.businessType}).pipe(map(res => res['data']));
  }

  getCurrentSubSysTagCategories(useCache?: boolean): Observable<any> {
    this.businessType = this.storageService.getBusinessTypeItem();
    if (useCache) {
      if (!this.tagData$) {
        this.tagData$ = forkJoin([
          this.tagData1$,
          this.tagData2$
        ]).pipe(
            map(res => {
              const data1 = res[0] as any[];
              const data2 = res[1] as any[];
              const allTag = data1.concat(data2);
              allTag.sort((a, b) => b.id - a.id);
              return allTag
            }),
            shareReplay(1)
        );
      }
      setTimeout(() => {
        this.tagData$ = null;
      }, 60000);
      return this.tagData$;
    } else {
      return this.tagData$ = forkJoin([
        this.http.post(this.httpBase + '/tag/tagCategory/search', {businessType: -1}).pipe(map(res => res['data'])),
        this.http.post(this.httpBase + '/tag/tagCategory/search', {businessType: this.businessType}).pipe(map(res => res['data']))
      ]).pipe(
          map(res => {
            const data1 = res[0] as any[];
            const data2 = res[1] as any[];
            const allTag = data1.concat(data2);
            allTag.sort((a, b) => b.id - a.id);
            return allTag
          }),
          shareReplay(1)
      );
    }
  }

  clearCache() {
    this.tagData$ = null;
    this.tagData1$ = null;
    this.tagData2$ = null;
    return super.clearCache();
  }
}
